import { IFiltersList, ITableResponse } from "../types/applicationOnline";
import { IApplyOnline } from "../types/applyOnline";
import { apiType } from "./apiType";

export const applicationPageRequests = {
  getList: async (limit: string, offset: number, office: string, data?: object) => {
    try {
      if (data) {
        return await apiType.main.post<ITableResponse>(`/forms/filters/apply?office=${office}&limit=${limit}&offset=${offset}`, data);
      } else {
        return await apiType.main.get<ITableResponse>(`/forms/list?limit=${limit}&offset=${offset}&office=${office}`);
      }
    } catch (error) {
      console.log("Это ошибка getList:", error);
      return null;
    }
  },
  getFilterList: async (office: string) => {
    try {
      return await apiType.main.get<IFiltersList>(`/forms/filters/list?office=${office}`);
    } catch (error) {
      console.log("Это ошибка getList:", error);
      return null;
    }
  },
  update: (data: object) => apiType.main.put<ITableResponse>(`/forms/update/`, data),
  delete: async (data: number[]) => {
    try {
      await apiType.main.delete(`/forms/delete/`, { data });
      console.log("Удалено успешно");
    } catch (error) {
      console.log("Это ошибка при delete:", error);
    }
  },
  create: async (data: object) => {
    try {
      await apiType.main.post<IApplyOnline>("/forms/create", data);
      console.log("Успешный успех");
    } catch (error) {
      console.log("Это ошибка при create:", error);
    }
  },
};
